export default class formConfig {
  // 招标计划
  static configList() {
    return [
      {
        title: "项目信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "招标公告编号：",
            type: "slot",
            slotName: "announcementId",
            disabled: true,
            rule: {
              required: true,
              message: "请填写招标公告编号",
              trigger: "blur"
            }
          },
          {
            label: "招标登记编号：",
            type: "input",
            value: "registrationId",
            disabled: true,
            rule: {
              required: true,
              message: "请填写招标登记编号",
              trigger: "blur"
            }
          },
          {
            label: "招标编号：",
            type: "input",
            value: "tenderReference",
            disabled: true,
            rule: {
              required: true,
              message: "请填写招标编号",
              trigger: "blur"
            }
          },
          {
            label: "项目名称：",
            type: "input",
            value: "prjName",
            tip: "（项目信息框中的数据从“项目信息”按钮中选择。）",
            disabled: true,
            rule: {
              required: true,
              message: "请填写项目名称",
              trigger: "blur"
            }
          },
          {
            label: "标段号：",
            type: "input",
            value: "section",
            disabled: true,
            rule: {
              required: true,
              message: "请填写标段号",
              trigger: "blur"
            }
          },
          {
            label: "行政监督部门：",
            value: "regulators",
            type: "select",
            required: true,
            disabled: true,
            rule: {
              required: true,
              message: "请选择行政监督部门",
              trigger: "change"
            },
            queryParams: {
              url: "/regulatorsCombobox",
              processType: "201604141747323854"
            }
          },
          {
            label: "招标人：",
            type: "input",
            value: "tenderCorpName",
            disabled: true,
            rule: {
              required: true,
              message: "请填写招标人",
              trigger: "blur"
            }
          },
          {
            label: "招标联系人：",
            type: "input",
            value: "tenderLinkMan",
            disabled: true,
            rule: {
              required: true,
              message: "请填写招标联系人",
              trigger: "blur"
            }
          },

          {
            label: "招标代理机构：",
            type: "input",
            value: "tenderAgentOrganName",
            disabled: true,
          },
          {
            label: "代理机构联系人：",
            type: "input",
            value: "agencyLinkMan",
            disabled: true,
          },
        ]
      },
      {
        title: "投标有效期信息",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "开标时间：",
            type: "input",
            value: "openingTime",
            disabled: true,
            rule: {
              required: true,
              message: "请填写开标时间",
              trigger: "blur"
            }
          },
          {
            label: "原投标有效期（日历天）：",
            type: "input",
            value: "oldTenderValidityDay",
            disabled: true,
            rule: {
              required: true,
              message: "请填写原投标有效期（日历天）",
              trigger: "blur"
            }
          },
          {
            label: "原投标有效期截止时间：",
            type: "input",
            value: "oldTenderValidity",
            disabled: true,
            rule: {
              required: true,
              message: "请填写原投标有效期截止时间",
              trigger: "blur"
            }
          },
          {
            label: "变更后的投标有效期（日历天）：",
            type: "input",
            value: "tenderValidityChangeDay",
            placeholder: "请输入",
            tip: "（只能输入数字）",
            maxlength: 5,
            rule: [
              {
                required: true,
                message: "请填写变更后的投标有效期（日历天）",
                trigger: "blur"
              },
              {
                pattern: /^([1-9]\d*|0)(\.\d{1,6})?$$/,
                message: "请输入数字"
              }
            ]
          },
          {
            label: "变更后的投标有效期截止时间：",
            type: "input",
            value: "endDate",
            tip: "（该截止时间是根据开标时间加上填写的投标有效期日历天推送出来）",
            disabled: true,
            rule: {
              required: true,
              message: "请填写变更后的投标有效期截止时间",
              trigger: "blur"
            }
          },
          {
            label: "变更原因：",
            value: "changeReason",
            type: "textarea",
            width: "100%;",
            required: true,
            maxlength: 1200,
            minRows: "3",
            maxRows: "2",
            rule: {
              required: true,
              message: "请填写变更原因",
              trigger: "blur"
            }
          },
        ]
      },
      {
        title: "其他",
        name: "3",
        icon: "",
        formConfigList: [
          // {
          //   label: "核验记录：",
          //   type: "slot",
          //   slotName: "state",
          // },
          {
            label: "招标人意见：",
            value: "tenderOpinion",
            type: "textarea",
            required: true,
            maxlength: 900,
            minRows: "3",
            maxRows: "2",
            disabled: true,
            width: "100%;",
          },
        ]
      },
    ];
  }
}
